import { SimpleGrid, Stack, useText } from "@sveabank/cc-common";
import { UspListItem } from "../../../components/bullet-list/usp-list-item";
import type { ForetagarnaCreditPackage } from "../../../types/package";
import PackageBlock from "./package-block";

type Props = {
	foretagarnaCreditPackage?: ForetagarnaCreditPackage;
};

const ForetagarnaCreditPackageBlock = ({ foretagarnaCreditPackage }: Props) => {
	const [t, texts] = useText();

	if (!foretagarnaCreditPackage) return null;

	const text = texts.choosePackage[foretagarnaCreditPackage.packageId];

	return (
		<PackageBlock
			heading={t(text.title)}
			headingColor="text-text-contrast"
			onboardingPackage={foretagarnaCreditPackage}
			bgColor="bg-background-foretagarna"
			imageSrc="FORETAGARNA_DASHBOARD"
			moreAbout={t(text.moreAbout)}
			hasFromLabel={false}
		>
			<Stack component="ul" gap={4}>
				<SimpleGrid cols={2} gap={1}>
					<UspListItem text={t(text.desktop.bullet1)} />
					<UspListItem text={t(text.desktop.bullet2)} />
					<UspListItem text={t(text.desktop.bullet3)} />
					<UspListItem text={t(text.desktop.bullet4)} />
				</SimpleGrid>
			</Stack>
		</PackageBlock>
	);
};

export default ForetagarnaCreditPackageBlock;
